/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";
import Lottie from "react-lottie";
import LottieNotFound from "../../../../animations/lottie_not_found.json";

const useStyles = makeStyles((theme) => ({
  gridMain: {
    width: "80%",
    top: "30%",
    position: "absolute",
  },
}));

export default function NotAttendanceFound(props) {
  const classes = useStyles();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieNotFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      className={classes.gridMain}
      style={{marginTop: 70}}
    >
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} height={300} width={300} />
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 26,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          No se han encontrado asistencias
        </Typography>
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 18,
            color: "#acacac",
          }}
        >
          No hemos encontrado asistencias en la búsqueda
        </Typography>
      </Grid>
    </Grid>
  );
}
